module.exports = __webpack_public_path__ + "media/5.9334ab28.mp3";